var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FFDCDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2478 21.2108C9.55491 21.7031 10.0879 22.0012 10.6705 22.0012H21.3295C21.9121 22.0012 22.4451 21.7031 22.7522 21.2108C23.0548 20.714 23.0819 20.1043 22.8245 19.5849L17.4904 8.92136C17.2059 8.3568 16.6368 8 16 8C15.3632 8 14.7941 8.3568 14.5096 8.92136L9.17554 19.5849C8.9181 20.1088 8.94519 20.714 9.2478 21.2108ZM16.6775 12.4984V16.8027C16.6775 17.1776 16.3749 17.4802 16 17.4802C15.6251 17.4802 15.3225 17.1776 15.3225 16.8027V12.4984C15.3225 12.1236 15.6251 11.821 16 11.821C16.3749 11.821 16.6775 12.1236 16.6775 12.4984ZM15.3225 19.2732V18.7809C15.3225 18.4061 15.6251 18.1035 16 18.1035C16.3749 18.1035 16.6775 18.4061 16.6775 18.7809V19.2732C16.6775 19.6436 16.3749 19.9507 16 19.9507C15.6251 19.9507 15.3225 19.6436 15.3225 19.2732Z",
    fill: "#FB2525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.b4c976c54c9f66fb93b1965911358731.svg";
export { ForwardRef as ReactComponent };